
/* styles */
require("!!vue-style-loader!css-loader!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-cff436fa&scoped=true!sass-loader!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./DemoLogin.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./DemoLogin.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-cff436fa!../../node_modules/vue-loader/lib/selector?type=template&index=0!./DemoLogin.vue"),
  /* scopeId */
  "data-v-cff436fa",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/page/DemoLogin.vue
// module id = 605
// module chunks = 0